import { Icon } from '@barev/ui';
import { paramsSummary, useI18n } from '@barev/web';
import type { ReactNode } from 'react';

export function PageHead({ title, back = true }: { title: ReactNode; back?: boolean }) {
  const { t } = useI18n();
  return (
    <div className="page-head">
      {back && (
        <button className="back" onClick={() => window.history.back()} aria-label={t('common.back')}>
          <Icon name="back" />
        </button>
      )}
      <h1 className="bc-h2" style={{ flex: 1 }}>
        {title}
      </h1>
    </div>
  );
}

export interface JobLike {
  id: string;
  number: number;
  flow: string;
  status: string;
  serviceCode: string;
  scheduledAt: Date;
  isOnline: boolean;
  addressText: string | null;
  districtCode: string | null;
  clientLocale: string;
  params: Record<string, unknown>;
}

export function useJobSummary() {
  const { t } = useI18n();
  return (j: Pick<JobLike, 'serviceCode' | 'params'>) => paramsSummary(t, j.serviceCode, j.params) || t(`services.${j.serviceCode}.name`);
}

/** Строка заказа: время, район/онлайн, язык клиента */
export function JobRow({ j, href, right }: { j: JobLike; href?: string; right?: ReactNode }) {
  const { t, dt } = useI18n();
  const summary = useJobSummary();
  const body = (
    <>
      <div className="job__time">{dt(j.scheduledAt, { hour: '2-digit', minute: '2-digit' })}</div>
      <div className="job__main">
        <div className="ellipsis" style={{ fontWeight: 600 }}>
          {summary(j)}
        </div>
        <div className="bc-small bc-muted ellipsis">
          {j.isOnline ? t('common.online') : j.districtCode ? t(`districts.${j.districtCode}`) : ''} · {j.clientLocale.toUpperCase()}
        </div>
      </div>
      {right ?? <span className="bc-badge" style={{ background: 'var(--bc-bg)' }}>{t(`status.${j.flow}.${j.status}`)}</span>}
    </>
  );
  return href ? (
    <a className="job" href={href}>
      {body}
    </a>
  ) : (
    <div className="job">{body}</div>
  );
}
